__turbopack_context__.v({
  "container": "loading-module-scss-module__ERoEdG__container",
  "default": "loading-module-scss-module__ERoEdG__default",
  "dot": "loading-module-scss-module__ERoEdG__dot",
  "even": "loading-module-scss-module__ERoEdG__even",
  "large": "loading-module-scss-module__ERoEdG__large",
  "lg": "loading-module-scss-module__ERoEdG__lg",
  "md": "loading-module-scss-module__ERoEdG__md",
  "medium": "loading-module-scss-module__ERoEdG__medium",
  "odd": "loading-module-scss-module__ERoEdG__odd",
  "primary": "loading-module-scss-module__ERoEdG__primary",
  "root": "loading-module-scss-module__ERoEdG__root",
  "scale": "loading-module-scss-module__ERoEdG__scale",
  "secondary": "loading-module-scss-module__ERoEdG__secondary",
  "sm": "loading-module-scss-module__ERoEdG__sm",
  "small": "loading-module-scss-module__ERoEdG__small",
  "spin": "loading-module-scss-module__ERoEdG__spin",
  "success": "loading-module-scss-module__ERoEdG__success",
  "white": "loading-module-scss-module__ERoEdG__white",
  "xs": "loading-module-scss-module__ERoEdG__xs",
});
